// extracted by mini-css-extract-plugin
export var active = "_hc-7";
export var blink = "_hc-8";
export var dropDownSelector = "_hc-4";
export var dropDownWrapper = "_hc-3";
export var fakeCursor = "_hc-6";
export var fontSizeButton = "_hc-9";
export var formQuillEditor = "_hc-0";
export var pressed = "_hc-a";
export var qlBlank = "_hc-1";
export var textFormattingToolbar = "_hc-2";
export var textToolbarOption = "_hc-5";